module.exports = __webpack_public_path__ + "static/media/maizieEdnaJo31.bf477339.png";